import { isValidLoginStatus, isVaildAccessToken } from '../shared/validation/login'
import axios from 'axios'
import store from '../store/index'
import packageFile from '../../package.json'
import router from '@/router/index'

const api = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT,
  headers: { Pragma: 'no-cache', 'Content-Type': 'application/json', 'appversion': packageFile.version }
})

// api.defaults.timeout = 5000
// 모든 통신시 header에 accessToken 전달하는 interceptors
api.interceptors.request.use(
  async (config) => {
    if ((config.url !== 'v1/restaurants') && (!isValidLoginStatus())) {
      router.push('/login')
      throw new axios.Cancel('is not valid loginstatus!!')
    }
    const axiosConfig = config
    const token = store.getters.getAccessToken
    if (token) {
      if (token !== axiosConfig.headers.Authorization) {
        axiosConfig.headers.Authorization = token
      }
      if (isVaildAccessToken()) {
        const { data: newToken } = await (function () {
          return axios.post(`${process.env.VUE_APP_API_ENDPOINT}/v1/login/refresh`, {
            refreshToken: store.getters.getRefreshToken
          }).then(
            (res) => res
          ).catch(() => {
            store.commit('setAccessToken', '')
            if (router.app.$route.name !== 'login') {
              router.push('/login')
            }
          })
        }())
        if (newToken) {
          axiosConfig.headers.Authorization = `Bearer ${newToken.accessToken}`
          store.commit('setAccessToken', `Bearer ${newToken.accessToken}`)
        }
      }
      // 해더에 clientId 추가
      const clientId = token.split(' ')[1]
      if (clientId) {
        axiosConfig.headers.clientId = clientId
      }
    } else {
      if (router.app.$route.name !== 'login') {
        router.push('/login')
      }
    }
    return config
  },
  (error) => Promise.reject(error)
)
api.interceptors.response.use((response) => response,
  (error) => {
    if (axios.isCancel(error)) {
      return new Promise(() => {})
    } else {
      const { response } = error
      const err = response.data.error
      if (err.status === 503 && err.errorCode === 'SERVER_MAINTENANCE') {
        store.commit('mutationByKeyValue', [{ key: 'isMaintenanced', value: true }])
      } else {
        store.commit('mutationByKeyValue', [{ key: 'isMaintenanced', value: false }])
      }
      if (err.status === 401 && err.name === 'UnauthorizedError') {
        router.push('/login')
      }
      return Promise.reject(error)
    }
  })
export default api
